import Vue from 'vue';
import { Portal, PortalTarget } from 'portal-vue';
import ButtonBack from '@/features/common/components/ButtonBack.vue';
import CountrySelect from '@/features/common/components/CountrySelect.vue';
import DoughnutWithLabel from '@/features/common/components/DoughnutWithLabel.vue';
import Dropdown from '@/features/common/components/Dropdown.vue';
import LineChart from '@/features/common/components/LineChart.vue';
import PeriodPicker from '@/features/common/components/PeriodPicker.vue';
import Tooltip from '@/features/common/components/Tooltip.vue';
import AlertDialog from '@/features/common/components/AlertDialog.vue';
import ConfirmationDialog from '@/features/common/components/ConfirmationDialog.vue';
import InputPostalCode from '@/features/common/components/InputPostalCode.vue';
import NotificationOops from '@/features/common/components/NotificationOops.vue';
import DatePicker from '@/features/common/components/DatePicker.vue';
import BaseTabs from '@/features/common/components/BaseTabs.vue';
import ImageProvider from '@/features/common/components/ImageProvider.vue';
import DefaultPageLayout from '@/features/common/layouts/DefaultPageLayout.vue';
import FeatureFlagWrapper from '@/features/common/components/feature-flag/FeatureFlagWrapper.vue';

Vue.component('ButtonBack', ButtonBack);
Vue.component('CountrySelect', CountrySelect);
Vue.component('DoughnutWithLabel', DoughnutWithLabel);
Vue.component('Dropdown', Dropdown);
Vue.component('LineChart', LineChart);
Vue.component('PeriodPicker', PeriodPicker);
Vue.component('Tooltip', Tooltip);
Vue.component('AlertDialog', AlertDialog);
Vue.component('ConfirmationDialog', ConfirmationDialog);
Vue.component('InputPostalCode', InputPostalCode);
Vue.component('NotificationOops', NotificationOops);
Vue.component('DatePicker', DatePicker);
Vue.component('BaseTabs', BaseTabs);
Vue.component('ImageProvider', ImageProvider);
Vue.component('Portal', Portal);
Vue.component('PortalTarget', PortalTarget);
Vue.component('DefaultPageLayout', DefaultPageLayout);
Vue.component('FeatureFlagWrapper', FeatureFlagWrapper);
